import React, { useContext, useState } from 'react';
import './SwitchDirection.module.scss';
import { faBriefcase, faSchool } from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/Button';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'react-tippy';

import { QuizContext } from 'screens/Quiz/Quiz';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProgressBar from '../../ProgressBar/ProgressBar';
import SkeletonCard from '../components/SkeletonCard/SkeletonCard';
import Content from '../components/Content/Content';
import SwitchDirectionBar from './components/SwitchDirectionBar/SwitchDirectionBar';

const buttons = [
    {
        image: '/images/test/switch-directions/volledig.jpg',
        icon: faSchool,
        buttonText: 'Ik wil een volledige overstap maken',
        text: 'Volledige overstap',
        description:
            'Je wilt graag iets toevoegen aan de samenleving om kinderen, jongeren, volwassenen een stapje verder helpen. Werken in het onderwijs is écht mensenwerk. En mensen die al wat meer levenservaring én ervaring vanuit een ander beroepenveld meebrengen, zijn meer dan welkom. Er zijn verschillende trajecten voor de verschillende onderwijstypes. ',
        answerLabel: 'full-switch',
    },
    {
        image: '/images/test/switch-directions/hybride.jpg',
        icon: faBriefcase,
        buttonText: 'Ik wil hybride overstappen (werken en het onderwijs in)',
        text: 'Hybride overstap',
        description:
            'De hybride leraar brengt praktijkkennis de schoolbanken in. Hoe het hybride leraarschap wordt ingevuld is maatwerk. Wat heb jij te bieden, wat heeft een onderwijsinstelling nodig en hoe vinden jullie elkaar? Bij het hybride leraarschap gelden wel dezelfde landelijke regels voor een bevoegdheid. Je mag dus alleen met een bevoegdheid voor de klas. ',
        answerLabel: 'hybrid',
    },
];

export default function SwitchDirection() {
    const [activeButton, setActiveButton] = useState(null);
    const { setQuestionIndex, setAnswers, answers } = useContext(QuizContext);

    function toNextScreen() {
        setQuestionIndex((prev) => prev + 1);
        setAnswers({
            ...answers,
            question2: buttons[activeButton].answerLabel,
        });
    }

    return (
        <div styleName="switch-direction">
            <div styleName="title">
                <h2>Wat voor overstap wil je maken?</h2>
                <ProgressBar />
            </div>
            <div styleName="question">
                <div styleName="buttons">
                    {buttons.map((button, index) => (
                        <SwitchDirectionBar
                            onClick={() => {
                                setActiveButton(index);
                            }}
                            active={activeButton === index}
                            key={index}
                            icon={button?.icon}
                            text={button?.buttonText}
                        />
                    ))}
                </div>
            </div>
            <div styleName="bottom">
                <Button
                    color="blue-gray"
                    onClick={() => setQuestionIndex((prev) => prev - 1)}
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                    Vorige
                </Button>
                <Tooltip
                    // theme="light"
                    disabled={activeButton !== null}
                    style={{ width: 'fit-content' }}
                    title="Je hebt nog geen antwoord ingevuld"
                >
                    <Button
                        color="blue"
                        disabled={activeButton === null}
                        onClick={toNextScreen}
                    >
                        Volgende
                        <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                </Tooltip>
            </div>
            <div styleName="info">
                {activeButton !== null ? (
                    <Content content={buttons[activeButton]} />
                ) : (
                    <SkeletonCard />
                )}
            </div>
        </div>
    );
}
